import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-tracker-status',
  templateUrl: './progress-tracker-status.component.html',
  styleUrls: ['./progress-tracker-status.component.scss']
})
export class ProgressTrackerStatusComponent implements OnInit {

  @Input() tabCode: string;
  @Input() tabType: string;
  public statusList: any;

  public cpqpNominationStatus = [
    {title: 'Not Started', icoColor: 'white'},
    {title: 'Ready to Start', icoColor: 'gray'},
    {title: 'Data Input', icoColor: 'orange'},
    {title: 'Endorse Stage 1', icoColor: 'orange-1'},
    {title: 'Endorse Stage 2', icoColor: 'orange-2'},
    {title: 'Approve CP/QP', icoColor: 'blue'},
    {title: 'Complete', icoColor: 'success'},
    {title: 'Rejected', icoColor: 'danger'},
    {title: 'Processing Failed', icoColor: 'purple'}
  ];

  public reportingWorkflowDataCaptureStatus = [
    {title: 'Not Started', icoColor: 'white'},
    {title: 'Ready to Start', icoColor: 'gray'},
    {title: 'Data Entry', icoColor: 'orange'},
    {title: 'Review by ORC', icoColor: 'blue'},
    {title: 'Endorse Stage 1', icoColor: 'orange-1'},
    {title: 'Endorse Stage 2', icoColor: 'orange-2'},
    {title: 'Complete', icoColor: 'success'},
    {title: 'Rejected', icoColor: 'danger'},
    {title: 'Processing Failed', icoColor: 'purple'}
  ];

  public reportingWorkflowVerifyConsentStatus = [
    {title: 'Not Started', icoColor: 'white'},
    {title: 'Ready to Start', icoColor: 'gray'},
    {title: 'Upload Documents', icoColor: 'orange'},
    {title: 'Upload Printer Proof', icoColor: 'orange-3'},
    {title: 'Acknowledgement', icoColor: 'orange-1'},
    {title: 'Consent to Publish', icoColor: 'orange-2'},
    {title: 'Complete', icoColor: 'success'},
    {title: 'Rejected', icoColor: 'danger'},
    {title: 'Processing Failed', icoColor: 'purple'}
  ];

  constructor() { }

  ngOnInit(): void {
    if (this.tabCode === '2') {
      this.statusList = this.cpqpNominationStatus;
    } else if (this.tabCode === '1') {
      if (this.tabType === '1') {
        this.statusList = this.reportingWorkflowDataCaptureStatus;
      } else {
        this.statusList = this.reportingWorkflowVerifyConsentStatus;
      }
    }
  }

}
